import { Dispatch } from 'redux'

export const SET_TABLEFILTER = 'SET_TABLEFILTER'

export type ISetTableFilterAction = {
  type: typeof SET_TABLEFILTER
  payload: {
    path: string
    data: any
  }
}

// path = vilken tabell/flik (t.ex. 'medarbetare' | 'brukare') så varje tabell har egen sort/filter-state.
export const setTableFilterAction = (path: string, filter: any, sorter: any, dispatch: Dispatch<any>) => {
  dispatch({
    type: SET_TABLEFILTER,
    payload: {
      path,
      data: { filter: filter, sorter: sorter },
    },
  })
}

export type Actions = ISetTableFilterAction
